
import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Stack, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// ------------------------------------------------------------------------------------------------

SlabModalPopUp.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    cancel: PropTypes.func,
    title: PropTypes.string,
    
};
// ------------------------------------------------------------------------------------------------

export default function SlabModalPopUp(props) {
    const { children, cancel, title } = props;

    const handleCancel = () => {
        cancel(false);
    };

    return (
        <div>
            <Modal open >
                <Box sx={{               
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    p: 0.7,
                    borderRadius: 1.5,
                    width: { xs: '90%', sm: '70%', md: '65%' },
                    maxHeight: '98%',                 
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    flex: 1,
                }}>
                    

                            <Stack
                                direction='row'
                                alignItems='center'
                                justifyContent='space-between'
                                mb={1}
                                sx={{ bgcolor: '#20b2aa', height: 40, borderRadius: '8px' }}
                            >
                                <Typography variant='h6' sx={{ color: '#fff', p: 1 }}>
                            {title}
                            </Typography>

                        <IconButton onClick={handleCancel} sx={{ p: 0, color: '#fff' }}>
                            <CloseIcon sx={{ width: '20px', height: '20px' }} />
                        </IconButton>

           
                    </Stack>

                    <Divider sx={{ mb: 1 }} />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        minHeight: 0,
                    }}>
                        {children}
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}
